import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-onyx-root',
    templateUrl: './onyx.component.html',
    styleUrls: ['./onyx.component.scss']
})
export class OnyxComponent {

    constructor(
    ) {
    }
}


